import { render } from "./profilehead.vue?vue&type=template&id=c5688542"
import script from "./profilehead.vue?vue&type=script&lang=js"
export * from "./profilehead.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__